export default {
  gnb: {
    name: 'Reward Points',
    menu: {
      point: 'Points',
      withdrawInfo: 'Withdrawal',
      faq: 'FAQ',
      pointHistory: 'Point History',
      pointExchangeHistory: 'Point Redemption History',
      userAuth: 'Identity verification information',
    },
    login: 'Login',
    logout: 'Logout',
  },
  fnb: {
    menu: {
      pointHistory: 'Point History',
      pointExchangeHistory: 'Point Redemption History',
    },
  },
  footer: {
    useOfTerms: 'Terms and Conditions',
    userPolicy: 'Privacy Policy',
    operationPolicy: 'Operation Policy',
  },
  common: {
    title: 'My Points',
    pointRedemptionInfo: 'Information on Point Redemption',
    textExpire: 'Expiring This Month',
    textExpireGlobal: 'Expiring Soon',
    textExpiryInSettlement: 'Expiring This Month - Settlement in progress',
    textLost: 'Expires on {date}',
    textInfo: 'How to Redeem Points',
    btnExchange: 'Apply for Redemption',
    btnSearch: 'Search',
    btnDesc: 'Details',
    confirm: 'OK',
    cancel: 'cancel',
    next: 'Next',
  },
  date: {
    selectMonth: 'Choose Period',
    year: ' -',
    month: '',
    middle: ' to ',
  },
  // page - intro
  intro: {
    title: 'Reward Point Service',
    desc: 'Reward Redeemed in Cash<br>Real Cashback Reward',
    title_list: 'Reward Points',
    default_text: 'There is no reward point service.',
    initial_text: 'Log in to check your reward points.',
  },
  // page - 포인트 내역
  pointHistory: {
    statusList: ['Earn', 'Use', 'Cancel'],
    earn: 'Earn NEXON CREATORS',
    chargeCampaignPoint: 'Earn NEXON CREATORS CAMPAIGN',
    rewardPoint: 'Earn Reward Points',
    chargeNConnectReward: 'N-CONNECT Reward',
    cancelEarn: 'Cancel Earning NEXON CREATORS',
    chargeCampaignPointMinus: 'Cancel Earning NEXON CREATORS CAMPAIGN',
    lostPoint: 'Points Lost',
    expiredPoint: 'Points Expired',
    requestExchangePoint: 'Apply for Point Redemption',
    withdrawPersonBalance: 'Withdraw Personal Balance',
    cancelRequestExchangePoint: 'Cancel Point Redemption Payment for Application Made on {date}', // MM/DD/YYYY
    businessRegularProfit: 'Regular Business Profit Made for {month} {year}',
    withdrawBusinessBalance: 'Withdraw Business Balance ',
    cancelBusinessRegularPayment: 'Cancel Payment of Regular Business Profit Made for {month} {year}',
    chargeLiveDonation: 'Points Issued',
    chargeLiveDonationMinus: 'Points Reclaim',
    pointsIssued: 'Points Issued',
    pointsReclaim: 'Points Reclaim',
    expiryDate: 'Expiry Date',
    plus: 'Earn',
    minus: 'Use',
    cancel: 'Cancel',
    subContentExtra: {
      cancelChargeByRefund: 'Points cancelled due to refunds',
      withdrawCreator: 'Termination of creator status',
      resetIdentifyVerification: 'Reset Identity Verification',
      failWithdrawal: 'Withdrawal failed',
      cancelGlobalExchangeRequest: 'Payment Solution Rejected',
      creatorSanction: 'Creator Sanctions',
      policyViolation: 'Policy Violation',
      // pointTransferOperations: 'Points Issued',
      // pointTransferAccountHolderChange: 'Points Issued',
      pointTransferOperations: 'Points Transferred due to Operations',
      pointTransferAccountHolderChange: 'Points Transferred due to Account Holder Change',
    },
  },
  // page - 포인트 전환 내역
  exchangeHistory: {
    statusList: ['All Status', 'Apply', 'Preparing', 'Canceled', 'In Progress', 'Successful', 'Failed', 'Rejected'], // krpc
    globalStatusList: [
      'All Status',
      'Apply',
      'In Progress',
      'Failed',
      'Successful',
      'Rejected',
      'Canceled',
      'Payment Failed (Error)',
    ], // global(krpc 외 계정)
    globalStatusRow: ['Apply', 'In Progress', 'Successful', 'Canceled', 'Rejected', 'Failed', 'Payment Failed (Error)'], // 포인트 전환 내역에 뜨는 상태
    caution: {
      title: 'Notes for Business Users',
      content: `
        <li>The points collected in the previous month by business users are automatically finalized and redeemed on the first day of the current month and the point redemption history is automatically created.</li>
        <li>Check the details and send us an e-tax invoice for the finalized amount to receive it. </li>
        <li>Send your e-tax invoice to <a href="mailto:rewardpoint_tax@nexon.co.kr">rewardpoint_tax@nexon.co.kr</a> by the 25th of each month. </li>
        <li>If you do not issue any tax invoice, the revenue or points for the month may be lost.</li>`,
      global: {
        title: 'Notes',
        content: `
          <p>[Cash]</p>
          <li>Once the withdrawal is approved, the deposit will be processed on the 15th of the following month. However, it may take up to 7 days or more due to international wire transfer.</li>
          <li>The requested withdrawal amount and the amount received may differ due to the wire transfer fee, etc.</li>
          <li>You can check the progress in more detail on the details page.</li>`,
        contentNexonPoint: `
          <p>[NEXON Points]</p>
          <li>NEXON Points conversion requests will be processed sequentially within 10 business days after the 21st of the application month and credited to accounts actively engaged in creator activities. </li>
          <li>Due to sequential processing, the timing of NEXON Points distribution may vary by creator.</li>`,
      },
    },
    requestExchangePoint: 'Apply for Point Redemption',
    businessRegularProfit: 'Regular Business Profit Made for {month} {year}',
    withdrawPersonBalance: 'Withdraw Personal Balance',
    withdrawBusinessBalance: 'Withdraw Business Balance ',
    global: {
      table: {
        column: {
          regiDate: 'Request Date',
          status: 'Status',
          withdrawPoint: 'Requested <br>Withdrawal Points',
          withdrawAmount: 'Requested <br>Withdrawal Amount',
          orderNo: 'Order Number',
          type: 'Withdrawal Type',
        },
      },
    },
  },
  // page - 출금 정보
  userInfo: {
    needVerifiedId:
      'You need a verified ID to apply<br/>Go to My Info > Manage My Info > Change Personal Information and verify yourself first.',
    removeWithdrawalInfo:
      'Are you sure you want to delete your withdrawal information? All entered information will be deleted.',
    underReview:
      'You have a business account under review. Withdrawal information cannot be deleted while it is being processed.',
    processingCompleted: 'Processing has been completed.',
  },
  // page - global
  global: {
    title: 'Point Withdrawal Application',
    titlePoint: 'Request NEXON Points Conversion',
    subTitle: 'Apply for Withdrawal',
    subTitlePoint: 'Apply for Conversion',
    mainText: `<span>Points can be redeemed</span> and withdrawn in cash.`,
    mainTextForNexonPoint: `<span>Points can be withdrawn as cash</span> or converted to NEXON Points.`,
    subText: `<span>Read the instructions and click Apply for Withdrawal</span> to proceed to the next step.`,
    applyGuide: 'Withdrawal Application Instructions',
    applyGuidePoint: 'NEXON Points Conversion Request Guide',
    applyBtn: 'Apply for Withdrawal',
    applyBtnPoint: 'Apply',
    detailButton: 'Check Details',
    available: '{pointName} available',
    withdrawPointInput: 'Enter Points for Conversion',
    withdrawNjPointInput: 'Enter Points for Conversion',
    withdrawAmount: 'Requested Withdrawal Amount',
    withdrawAmountPoint: 'NEXON Points Conversion Amount',
    transferFeeDescription: 'The actual amount received may differ due to wire transfer fees, etc.',
    transferFeeDescriptionPoint: 'The requested amount will be credited as NEXON Points.',
    confirmWithdrawCaution: 'I have read all of the precautions for withdrawal.',
    confirmWithdrawCautionPoint: 'I have reviewed all important notes regarding point conversion.',
    withdrawCaution: 'Precautions for Withdrawal',
    pointCaution: 'Precautions Related to NEXON Point Conversion',
    maxAmount: 'Max Amount',
    inputPlaceholder: 'Can be entered by {point}{unit}',
    withdrawCautionDescriptions: {
      1: 'You can withdraw between a minimum of {currency}{min} and a maximum of {currency}{max} at one time.',
      2: 'You cannot cancel point withdrawal once you have applied.',
      3: 'The requested withdrawal amount and the amount received may differ because a wire transfer fee is deducted.',
      4: 'If there is any unlawful activity in acquiring points or a problem with the application information such as the bank account, the withdrawal request may be rejected.',
      5: 'Details of withdrawal requests can be found in your point redemption history.',
      6: `
        <li>- Information (including personal information ,hereinafter, "provided information") provided by customers in the reward point monetization process (hereinafter, "this process") is only used for this process and for customer support.<br />
           It is managed according to this
          <a
            href="https://company.nexon.co.jp/support/privacypolicy.html?_gl=1*1vcfzsa*_gcl_au*MTc5MzY4NDg5LjE3MDA4MDc3MzA"
            target="_blank"
          >company's Personal Information Protection Policy</a>
          The provided information is provided to Tipalti, Inc. (located in California, USA), to whom this company entrusts the monetization process.<br />
          Tipalti, Inc. takes measures in compliance with the eight basic principles of the OECD Privacy Guidelines.<br />
        </li>
        <li>
          - For more information on the personal information protection-related system of California, USA, refer to the
          <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/" target="_blank">documentation</a> published by the Japanese Personal Information Protection Commission.
        </li>
        <li>
          - Please input the provided information accurately. This company is not liable for any disadvantages incurred by customers due to insufficiency of input content.
        </li>
      `,
    },
    withdrawPointCautionDescriptions: {
      1: 'You can apply for conversion from {min}{currency} to {max}{currency} per request.',
      2: 'Cancellation after application is not possible.',
      3: 'If fraudulent activity is detected in point accumulation, the withdrawal request may be rejected.',
      4: 'You can check your application details in the point withdrawal history.',
    },
    modalHeader: 'Withdrawal method selection.',
    modalTitle: 'Please select a withdrawal method.',
    modalDesc: `Applications are permitted only once per month.<br />Please carefully review the application procedure before making your selection.`,
    cash: 'Cash',
    nexonPoint: 'NEXON Points',
    nextStep: {
      1: 'Click the Next button to enter withdrawal information.',
      2: 'Please check the guide on the withdrawal information you need to enter in advance.',
      3: 'View Withdrawal Information Entry Guide',
    },
    nextStepForPoint: {
      1: `Click the 'Apply' button to finalize your NEXON Points conversion request.`,
      2: 'You can check the important notes for conversion requests in the guide below.',
      3: 'Application Guide',
    },
    withdrawFail: 'An error occurred during processing.<br/>Please try again.',
    withdrawSuccessTitle: 'Your point redemption application has been sent.',
    withdrawSuccessTitlePoint: 'Your point redemption application has been completed.',
    withdrawSuccessDesc:
      'It may take up to 30 minutes to process your application,<br/>and you can check the status from point redemption history.',
    withdrawSuccessDescPoint:
      'NEXON Points will be credited to the designated account after approval following the 21st of the current month.<br />You can check the progress in the point conversion history.',
    notAvailableCurrency:
      'Sorry for the inconvenience.<br/>The points cannot be used with the account you are currently logged in.',
    notAvailableAge:
      'Sorry for the inconvenience.<br/>Withdrawal application is available for members aged 14 or above.',
    notAvailablePeriod: 'Sorry, but this is not a withdrawal request period. Check the period before application.',
    notAvailableEmail:
      'Email verification has not been completed for this account.<br/>Only accounts with verified emails can request withdrawal.<br/>Please verify your email in the Nexon Account Settings menu.',
    notAvailableWithdrawCount:
      'Sorry for the inconvenience.<br/>You cannot request withdrawal as you’ve exceeded your monthly withdrawal request limit.',
    notAvailableEnoughPoint: "Sorry for the inconvenience.<br/>You don't have enough points to request withdrawal.",
    otpGuide:
      'For security purposes, you must input your personal information after setting the OTP.<br/>Do you want to set the OTP?',
    notFinishedReviewAuth:
      'We are still reviewing the identity verification information you registered.<br/>You can register again after the processing is complete.',
    notRegisteredAuth:
      'The identity verification information has not been registered.<br/>You can request a withdrawal after you register your identity verification information and the registered information has been verified.<br/>Do you want to register your identity verification information?',
    rejectedAuth:
      'The identity verification information you registered has been rejected.<br/>You can request a withdrawal after you register your identity verification information and the registered information has been verified.<br/>Do you want to edit your identity verification information? ',
    reApplicationAuth:
      'Re-application has been requested for the identity verification information you registered.<br/>Please check the reason for the re-application request through your email and then edit your identity verification information.<br/>Do you want to edit your identity verification information? ',
    confirmingAuth:
      'We are currently confirming your registered identity verification information.<br/>Please request a withdrawal after the identity verification is complete. ',
    noneOtp:
      'For security purposes, you can request a withdrawal after setting the OTP.<br/>Do you want to set the OTP? ',
    validation: {
      minWithdrawPoint: 'The minimum amount required to request is {minValue}{unit}.',
      maxWithdrawPoint: 'The maximum amount you can request is {maxValue}{unit}.',
      amountUnit: 'Request available in units of {unitValue}{unit}.',
      notHasEnoughPoint: 'The points you entered are greater than the points you have.',
      withdrawing: 'Please wait a moment. There is a request in progress.',
      notAvailableApplication:
        'Sorry for the inconvenience.<br/> You cannot request withdrawal with this account.<br/>Please check the withdrawal request instructions.',
      commonError: 'Sorry for the inconvenience.<br/> An unknown error has occurred. Please try again later.',
    },
    exchangeRate: 'Exchange rate {unitValue}{unit} = {currency} 1',
    exchangePointRate: 'Exchange rate {unitValue}{unit} = NEXON Point 1{currency}',
  },
  error: {
    point: {
      1: 'Cannot apply for point redemption<br>because the service is currently undergoing maintenance.<br>Please try again after the maintenance is complete.',
      3001: 'You need a verified ID to apply for point redemption.<br>Go to My Info > Manage My Info > Change Personal Information and verify yourself first.',
      3002: 'Customers under the age of 14 cannot apply for point redemption.',
      3004: "Cannot apply for point redemption because you don't have enough points.",
      3005: 'Cashback reward is available once a month.<br>You have already applied this month and cannot apply again.<br>Check your application in the point redemption history.',
      3006: "Cannot apply for point redemption because you don't have enough points.",
      3008: 'User information and bank account information must be registered before applying for point redemption.<br>Do you want to register now?',
      3009: 'Business users cannot apply for point redemption.<br>The points collected in the previous month by business users are automatically redeemed on the first day of the current month and the income can be claimed through an e-tax invoice.',
      3013: 'The minimum amount required to request is {minValue}{unit}.',
      3015: 'Sorry, but this is not a withdrawal request period. Check the period before application.',
      3017: '등록된 출금정보의 이름이 현재 회원정보와 일치하지 않습니다.<br>출금정보를 업데이트 해주세요.',
      default:
        'Sorry for the inconvenience.<br>Cannot apply for point redemption<br>due to an unknown error.<br>Please try again later.',
    },
    pointHistory: {
      0: 'There is no point history.',
      1: 'Cannot view the point history because the service is currently undergoing maintenance.<br>Please try again after the maintenance is complete.',
      default: 'Sorry for the inconvenience.<br>Sorry for the inconvenience.<br>Please try again later.',
    },
    exchangeHistory: {
      0: 'There is no point redemption history.',
      1: 'Cannot view the point redemption history because the service is currently undergoing maintenance.<br>Please try again after the maintenance is complete.',
      default: 'Sorry for the inconvenience.<br>Sorry for the inconvenience.<br>Please try again later.',
    },
    search: {
      day: 'The maximum search period is 31 days.<br>Please modify the date.',
      month: 'The maximum search period is 12 months.<br>Please modify the date.',
    },
    common: {
      temporaryError: 'A temporary error has occurred.<br/>Please try again later.',
      needLogin: 'Would you like to go to the login page?',
      needIdentity: 'Please verify your identity.',
      serviceNotAvailable: 'The service is currently unavailable.',
      notPossiblePointConversion: "It's not possible to apply for a point conversion.",
      retry: 'Please try again.',
      serviceConnectionError: 'Unable to complete due to service connection error. Please try again later.',
      maintenance: 'We are currently undergoing maintenance.',
      maintenanceDescription:
        'This service is currently undergoing maintenance. We apologize for any inconvenience this may cause.',
      errorPath: 'This is an invalid path.',
    },
    // 임시 에러 메시지
    temp: {
      global:
        'Sorry for the inconvenience.<br>Cannot apply for withdrawal at this time.<br>The withdrawal feature will be available around June.',
    },
  },
};
